// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Da4o","productName":"Table_productName__7wmyA"};